import styled from "@emotion/styled";
import { useParams } from "react-router-dom";
import {
  Button,
  DropdownMenu,
  Hr,
  IconEditItem,
  Link,
  List,
  Stack,
  Text,
} from "atoms";
import { paths } from "utils/paths";

interface ArtistProfileEditMenuProps {
  artistId: string;
  showAdminFeatures?: boolean;
  label?: React.ReactNode;
  isOpen: boolean;
  toggle: () => void;
}

function ArtistProfileEditMenu({
  artistId,
  showAdminFeatures,
  label,
  isOpen,
  toggle,
  ...props
}: ArtistProfileEditMenuProps) {
  const { galleryId, itemId } = useParams<{
    galleryId: string;
    itemId: string;
  }>();

  let editItemPath = "";
  let editItemLabel = "";
  if (galleryId) {
    editItemPath = paths.artistGalleryEdit(artistId, galleryId);
    editItemLabel = "Gallery";
  }
  if (itemId) {
    editItemPath = paths.artistGalleryItemEdit(artistId, itemId);
    editItemLabel = "Item";
  }

  return (
    <MenuWrapper {...props}>
      <MenuToggle
        type="button"
        size="xxs"
        onClick={toggle}
        aria-label={`${isOpen ? "Close" : "Open"} Edit menu`}
        aria-controls="#edit"
        aria-expanded={isOpen}
        variant="primary"
      >
        {label ?? (
          <>
            Edit <IconEditItem />
          </>
        )}
      </MenuToggle>

      <DropdownMenu isOpen={isOpen} id="edit">
        <Stack gap="sm">
          {/* <Text bold size="xxxs" textTransform="uppercase">
            Edit Artist Profile
          </Text> */}
          <List type="blank">
            <Stack gap="xs">
              <Li>
                <Link variant="blank" to={paths.artistPortfolioEdit(artistId)}>
                  Edit Portfolio
                </Link>
              </Li>
              <Li>
                <Link variant="blank" to={paths.artistFeaturedEdit(artistId)}>
                  Edit Featured Work
                </Link>
              </Li>
              <Li>
                <Link
                  variant="blank"
                  to={paths.artistProfileEditBeta(artistId)}
                >
                  Edit Profile Details
                </Link>
              </Li>

              {editItemPath && (
                <Li>
                  <Link variant="blank" to={editItemPath}>
                    Edit Current <span>{editItemLabel}</span>
                  </Link>
                </Li>
              )}
            </Stack>
          </List>

          {showAdminFeatures && (
            <>
              <Hr />

              <Text bold size="xxxs" textTransform="uppercase">
                Admin Options
              </Text>

              <List type="blank">
                <Stack gap="xs">
                  <Li>
                    <Link to={paths.artistUpdateCreate(artistId)}>
                      Post an Update
                    </Link>
                  </Li>
                  <Li>
                    <Link to={paths.artistClaimInvitation(artistId)}>
                      Invite Artist to Claim
                    </Link>
                  </Li>
                </Stack>
              </List>
            </>
          )}
        </Stack>
      </DropdownMenu>
    </MenuWrapper>
  );
}

const MenuWrapper = styled.div({
  right: 0,
  display: "block",
  position: "relative",
  width: "min-content",
});

const MenuToggle = styled(Button)({
  alignItems: "center",
  justifyContent: "center",
  paddingLeft: 10,
  paddingRight: 8,
  svg: {
    pointerEvents: "none",
    fontSize: "1em",
  },
});

const Li = styled.li({
  a: { textTransform: "none" },
  "&&": {
    display: "block",
  },
});
export { ArtistProfileEditMenu };
